import DecimalHoursField from './DecimalHoursField';

export default DecimalHoursField;
